// @ngInject
function caFeatureToggle(devFeaturesDialogService) {
    return {
        restrict: 'E',
        scope: {
            featureKey: '@'
        },
        template:
            '<label class="ca-feature-toggle" ng-if="visible">' +
                '<span class="ca-feature-toggle__switch" ng-click="toggle()" ng-class="{\'ca-feature-toggle__switch--on\': enabled}">' +
                    '<span class="ca-feature-toggle__track"></span>' +
                    '<span class="ca-feature-toggle__thumb"></span>' +
                '</span>' +
                '<span class="ca-feature-toggle__label">{{\'common.tryNewFeatures\' | translate}}</span>' +
            '</label>',
        link: function (scope) {
            scope.visible = true;
            scope.enabled = localStorage.getItem(scope.featureKey) !== 'false';

            scope.toggle = function () {
                scope.enabled = !scope.enabled;
                if (scope.enabled) {
                    localStorage.removeItem(scope.featureKey);
                } else {
                    localStorage.setItem(scope.featureKey, 'false');
                }
                window.location.reload();
            };
        }
    };
}

angular
    .module('directives.featureToggle', ['devFeaturesDialog'])
    .directive('caFeatureToggle', caFeatureToggle);
